import { DashboardFilters } from '../../dashboard/filters/dashboard-filters.model';
import * as _ from 'lodash';
import { PayRefundStatus, StaleDatedCheckDurationType } from '../stale-dated-check-view.model';

export class StaleDatedCheckFilters {
  private _originalDashboardFilters: DashboardFilters;

  constructor(
    public dashboardFilters: DashboardFilters = null,
    public durationType: StaleDatedCheckDurationType,
    public checkAmount: number = null,
    public employeeNumbers: string[] = [],
    public firstNames: string[] = [],
    public lastNames: string[] = [],
    public checkNo: string = null,
  ) {
    this._originalDashboardFilters = dashboardFilters;
    this.dashboardFilters = _.clone(dashboardFilters);
  }

  static compareFilters(
    a: StaleDatedCheckFilters,
    b: StaleDatedCheckFilters
  ): boolean {
    if (!!a !== !!b) {
      return false;
    }
    if (!a) {
      return true;
    }

    if (
      !DashboardFilters.compareFilters(a.dashboardFilters, b.dashboardFilters)
    ) {
      return false;
    }

    if (a.durationType !== b.durationType) {
      return false;
    }

    if (a.checkAmount !== b.checkAmount) {
      return false;
    }

    if (
      !DashboardFilters._compareArray(
        a.employeeNumbers,
        b.employeeNumbers
      )
    ) {
      return false;
    }
    if (!DashboardFilters._compareArray(a.firstNames, b.firstNames)) {
      return false;
    }
    if (!DashboardFilters._compareArray(a.lastNames, b.lastNames)) {
      return false;
    }
    if (a.checkNo !== b.checkNo) {
      return false;
    }
    return true;
  }

  static getRefundStatusTextKey(refundStatus: PayRefundStatus): string {
    switch (refundStatus) {
      case PayRefundStatus.Unknown:
        return 'STALE_DATED_CHECKS.PAY_ITEM_REFUND_STATUS_UNKNOWN';
      case PayRefundStatus.RefundPending:
        return 'STALE_DATED_CHECKS.PAY_ITEM_REFUND_STATUS_PENDING';
      case PayRefundStatus.RefundCompleted:
        return 'STALE_DATED_CHECKS.PAY_ITEM_REFUND_STATUS_COMPLETED';
      default:
        return 'STALE_DATED_CHECKS.PAY_ITEM_REFUND_STATUS_UNKNOWN';
    }
  }

  static getRefundStatusDescriptionKey(refundStatus: PayRefundStatus): string {
    return StaleDatedCheckFilters.getRefundStatusTextKey(refundStatus) + '_DESCRIPTION';
  }

  copy(newDashboardFilters: DashboardFilters): StaleDatedCheckFilters {
    return new StaleDatedCheckFilters(
      newDashboardFilters,
      this.durationType,
      this.checkAmount,
      this.employeeNumbers.slice(),
      this.firstNames.slice(),
      this.lastNames.slice(),
      this.checkNo,
    );
  }

  clone(): StaleDatedCheckFilters {
    const newFilters = this.copy(this._originalDashboardFilters);
    newFilters.dashboardFilters = _.clone(this.dashboardFilters);
    return newFilters;
  }

  reset() {
    this.dashboardFilters = _.clone(this._originalDashboardFilters);
    this.durationType = StaleDatedCheckDurationType.CurrentUpcomingStaleDatedChecks;
    this.checkAmount = null;
    this.employeeNumbers = [];
    this.firstNames = [];
    this.lastNames = [];
    this.checkNo = null;
  }

  public isAmountTooLow(): boolean {
    return this.checkAmount < -10000000000000.0;
  }
  public isAmountTooBig(): boolean {
    return this.checkAmount > 10000000000000.0;
  }

  public isFormInvalid(): boolean {
    return this.isAmountTooBig() || this.isAmountTooLow();
  }
}
